import { UploadOutlined } from '@ant-design/icons';
import { Button, message, Spin, Upload } from 'antd';
import { useState } from 'react';
import useLoginStore from 'store/loginStore';
import { postFileUpload } from 'utils/apiFunctions.js';

const SimpleFileUpload = ({ prefix, onUploadSuccess, acceptMime =  "image/png, image/jpeg"}) => {
    const [isUploading, setIsUploading] = useState(false);
    const currentRole = useLoginStore(s => s.getCurrentRole)();
    const handleUpload = async (file) => {
        try {
            setIsUploading(true);
            const response = await postFileUpload(file, { prefix}, currentRole);
            setIsUploading(false);
            console.log(response);
            if (response.status === 200) {
                const location = (await response.json()).location
                message.success(`${file.name} file uploaded successfully`);
                onUploadSuccess(location); 
            } else {
                let errorMessage = `${file.name} file upload failed`;
                try {
                    const data = await response.json();
                    if (data?.message) {
                        errorMessage = data.message;
                    }
                } catch (_) {
                    // Use default message if response body cannot be parsed
                }
                message.error(errorMessage);
            }
        } catch (error) {
            message.error(`${file.name} file upload failed`);
        }
    };

    const customRequest = ({ file, onSuccess }) => {
        handleUpload(file);
        onSuccess("ok"); // This is to trigger the antd upload success status
    };

    return (
        <Upload customRequest={customRequest} accept={acceptMime} showUploadList={false} >
            <Button icon={isUploading ? <Spin size="small" spinning={true} /> : <UploadOutlined />}>Upload from Computer</Button>
        </Upload>
    );
};

export default SimpleFileUpload;